<template>
  <div class="create-order">
    <div class="rule-nav">
      <div
        v-for="item in createOederNav"
        :key="item.index"
        class="nav_item"
        :class="{'active': item.index === active}"
        @click="changeIndex(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-form
      ref="form"
      class="create-order_form"
      :model="form"
      label-position="top"
      :rules="rules"
    >
      <div ref="site">
        <titleBlock
          class="title_bar"
          title="站点选择范围"
          alert-info="下单选择支持的站点编码所属范围（订单校验范围相同） "
        >
          <el-form-item label="站点范围:" prop="STATION_SCOPE.scope">
            <el-radio-group v-model="form.STATION_SCOPE.scope">
              <el-radio
                v-for="item in SITE_RULE"
                :key="item.value"
                border
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </titleBlock>
      </div>
      <div ref="goods">
        <titleBlock
          class="title_bar"
          title="货品选择范围"
          alert-info="下单支持选择的货主货品范围"
        >
          <el-form-item label="货品范围:" prop="SKU_SCOPE.scope">
            <el-radio-group v-model="form.SKU_SCOPE.scope">
              <el-radio
                v-for="item in SITE_RULE"
                :key="item.value"
                border
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <detailsView
            label="货品校验规则"
            :process-name="parentProcessName"
            :process-code="parentProcessCode"
            path="wwwwww"
            :field="detailField.GOODS_RULE"
            :form="form"
          />
        </titleBlock>
      </div>
      <div ref="order">
        <titleBlock
          ref="order"
          class="title_bar"
          title="下单时间校验"
        >
          <div class="text-wrapper">
            <span class="text1">允许补录</span>
            <span class="text2">开启后允许补录订单</span>
          </div>
          <el-switch
            v-model="form.MAKEUP_TIME_CHECK.flag"
            :disabled="isDisabled"
            active-color="#059E84"
            class="marginBottom"
            inactive-color="#D9DBDE"
          />
          <detailsView
            label="时间校验规则"
            :process-name="parentProcessName"
            :process-code="parentProcessCode"
            path="wwwwww"
            :field="detailField.TIME_RULE"
            :form="form"
          />
        </titleBlock>
      </div>
      <div ref="prepayment">
        <titleBlock
          ref="prepayment"
          class="title_bar"
          title="预计费规则"
        >
          <div class="text-wrapper">
            <span class="text1">预计费</span>
            <span class="text2">开启后订单页面下单返回预估金额</span>
          </div>
          <el-switch
            v-model="form.ADVANCE_PRICING.flag"
            class="marginBottom"
            active-color="#059E84"
            inactive-color="#D9DBDE"
          />
          <detailsView
            label="计费限额"
            :process-name="parentProcessName"
            :process-code="parentProcessCode"
            path="wwwwww"
            :field="detailField.BILL_QUOTA"
            :form="form"
          />
        </titleBlock>
      </div>
      <div ref="orderBusinessLabel" class="orderBusinessLabel">
        <titleBlock
          ref="prepayment"
          class="title_bar"
          title="订单业务标签"
        >
          <div class="flex align-center">
            <div class="flex align-center businessLabelItem">
              <span class="business_label">子母单</span>
              <el-tooltip
                content="开启后客户下单可选择子母单标识，相同标识的订单将合并计费"
                placement="right"
              >
                <span class="business_tips_text"><i class="el-icon-question" /></span>
              </el-tooltip>
            </div>
            <div class="flex align-center">
              <el-switch
                v-model="form.PARENT_MARK.flag"
                active-color="#059E84"
                inactive-color="#D9DBDE"
              />
              <el-button
                v-if="form.PARENT_MARK.flag"
                style="margin-left:24px"
                icon="el-icon-setting"
                size="mini"
                @click="handleConfig"
              >
                子母单标识{{ MarkListTotal||'' }}
              </el-button>
            </div>
          </div>
          <div class="flex align-center marginBottom">
            <div class="flex align-center businessLabelItem">
              <span class="business_label">打包计件</span>
              <el-tooltip
                content="业务上按照实际装车的打包件数进行统计的场景"
                placement="right"
              >
                <span class="business_tips_text"><i class="el-icon-question" /></span>
              </el-tooltip>
            </div>
            <div class="flex align-center">
              <el-switch
                v-model="form.CREATE_FLAG_PKG.flag"
                active-color="#059E84"
                inactive-color="#D9DBDE"
              />
            </div>
          </div>
        </titleBlock>
      </div>
      <!-- <div ref="multiPieces">
        <titleBlock
          ref="multiPieces"
          class="title_bar"
          title="子母单"
        >
          <template #info>
            <el-tooltip
              content="开启后客户下单可选择子母单标识，相同标识的订单将合并计费"
              placement="right"
            >
              <span class="tips_text"><i class="el-icon-question" /></span>
            </el-tooltip>
          </template>
          <div class="flex align-center marginBottom ">
            <el-switch
              v-model="form.PARENT_MARK.flag"
              active-color="#059E84"
              inactive-color="#D9DBDE"
            />
            <el-button
              v-if="form.PARENT_MARK.flag"
              style="margin-left:24px"
              icon="el-icon-setting"
              @click="handleConfig"
            >
              子母单标识{{ MarkListTotal||'' }}
            </el-button>
          </div>
        </titleBlock>
      </div> -->

      <div ref="timeoutNotification">
        <titleBlock
          ref="timeoutNotification"
          class="title_bar"
          title="下单任务预警"
        >
          <div class="flex align-center marginBottom ">
            <el-switch
              v-model="form.CREATE_NOTIFY.enableNotify"
              active-color="#059E84"
              inactive-color="#D9DBDE"
            />
            <span class="switch_tips">开启后通过消息提醒客户及时下单</span>
          </div>
          <timeoutNotification
            v-if="form.CREATE_NOTIFY.enableNotify"
            :form="form.CREATE_NOTIFY"
            :fields="createOrderTimeoutNotification"
          />
        </titleBlock>
      </div>
      <div ref="custom">
        <titleBlock ref="custom" title="自定义字段">
          <el-form-item label="自定义字段配置:">
            <el-checkbox-group
              v-model="form.CREATE_CUSTOM_FIELDS.fields"
            >
              <el-checkbox
                v-for="item in customFieldOption"
                :key="item.value"
                :label="item.label"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </titleBlock>
      </div>
    </el-form>
    <multiPiecesConfig ref="multiPiecesConfig" @refreshMarkTotal="handleRefreshMarkTotal" />
  </div>
</template>

<script>
import { processingSelectData } from '@/utils/index';
import ButtonPermission from '@/constant/buttonPermission';
import { mapState } from 'vuex';
import { twoNumberReg } from '@/utils/regExp';
import { getProjectList } from '@/api/user';
import { parentMarkList } from '@/views/shipperSeviceSetting/serveConfig/api';
import titleBlock from '../assembly/titleBlock.vue';
import {
  SITE_RULE, TIME_UNIT, createOederNav, detailField, markStatus, createOrderTimeoutNotification,
} from './const';
import detailsView from './detailsView.vue';
import multiPiecesConfig from './multiPiecesConfig.vue';
import timeoutNotification from './timeoutNotification.vue';

const reg = /^0(\.([1-9]|\d[1-9]))$|^999999$|^[1-9]\d{0,5}(\.\d{0,2})?$/;
const timeReg = /^[1-9]\d?$|^[1-2]\d{2}$|^3[0-5]\d$|^36[0-5]$/;
const integerReg = /^[0-9]*[1-9][0-9]*$/;
export default {
  components: {
    titleBlock, detailsView, multiPiecesConfig, timeoutNotification,
  },
  props: {
    customField: {
      type: Object,
      default: () => { },
    },
    customerCode: {
      type: String,
      default: null,
    },
    form: {
      type: Object,
      default: () => {},
    },
    parentProcessName: {
      type: String,
      default: '',
    },
    parentProcessCode: {
      type: String,
      default: '',
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const validateRange = (rule, value, callback) => {
      const { lower, upper } = value;
      const max = 999999;
      if (!reg.test(Number(lower)) || !reg.test(Number(upper)) || Number(lower) >= Number(upper)) {
        callback('请输入正确的范围');
      } else if (Number(lower) > max || Number(upper) > max) {
        callback('请输入正确的范围');
      }
      callback();
    };
    const validatezhongPaobi = (rule, value, callback) => {
      if (!integerReg.test(Number(value))) {
        callback('请输入正确的重泡比');
      }
      callback();
    };
    const validateTime = (rule, value, callback) => {
      if (!timeReg.test(Number(value))) {
        callback('请输入正确的时间');
      }
      callback();
    };
    const validateInsurePrice = (rule, value, callback) => {
      if (value && value !== '') {
        if (!twoNumberReg.test(value)) {
          callback(new Error('保留两位小数(0≤范围≤99999999.99)'));
        }
        const valueArr = (`${value}`).split('.');
        if (Number(valueArr[0] > 99999999)) {
          callback(new Error('整数值最大为99999999'));
        }
        callback();
      }
      callback();
    };

    return {
      validateInsurePrice,
      createOrderTimeoutNotification,
      SITE_RULE,
      createOederNav,
      detailField,
      active: 1,
      projectOptions: [],
      chooseProjectIds: [], // 选择的运营项目
      rules: {
        'STATION_SCOPE.scope': [
          { required: true, message: '请选择站点范围', trigger: 'change' },
        ],
        'SKU_SCOPE.scope': [
          { required: true, message: '请选择货品范围', trigger: 'change' },
        ],
        'CREATE_START_TIME.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
        'CREATE_REACH_TIME.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
        'MAKEUP_START_TIME.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
        'MAKEUP_REACH_TIME.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
        SKU_WEIGHT_RANGE: [
          { required: true, validator: validateRange, trigger: 'change' },
        ],
        SKU_VOLUME_RANGE: [
          { required: true, validator: validateRange, trigger: 'change' },
        ],
        SKU_SUM_RANGE: [
          { required: true, validator: validateRange, trigger: 'change' },
        ],
        'SKU_WEIGHT_VOLUME_RATIO.num': [
          { required: true, validator: validatezhongPaobi, trigger: 'change' },
        ],
        'INSURANCE.defaultValue': [
          { required: true, message: '请输入默认投保货值', trigger: 'change' },
          { validator: validateInsurePrice, trigger: 'change' },
        ],
      },
      MarkListTotal: 0, // 子母单标识数量
    };
  },
  computed: {
    ...mapState('user', ['buttonsPermission']),
    customFieldOption() {
      return processingSelectData(this.customField);
    },
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    isDisabled() {
      if (this.buttonsPermission && this.buttonsPermission.length) {
        return !this.buttonsPermission.map((item) => item.uri).includes(ButtonPermission.ALLOW_REPLENISH);
      }
      return true;
    },
  },
  watch: {
    customerCode: {
      handler(val) {
        if (val) {
          this.getProjectListFn();
          this.getParentMarkList();
        }
      },
      immediate: true,
    },
    'form.INSURANCE.rules': {
      handler(val) {
        if (!val || !val.length) {
          this.chooseProjectIds = [];
          return;
        }
        this.chooseProjectIds = val.map((t) => t.projectId);
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handelScroll, true);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handelScroll, true);
  },
  methods: {
    async getProjectListFn() {
      const data = await getProjectList({
        customerCodes: [this.customerCode],
        status: 'ENABLE',
      });
      this.projectOptions = data.length > 0 ? data.map((t) => ({
        label: t.projectName,
        value: t.id,
      })) : [];
    },
    changeIndex(item) {
      this.active = item.index;
      this.$refs[item.ref].scrollIntoView({ block: 'center' });
    },
    changeProject(val, index) {
      const tt = this.form.INSURANCE.rules[index];
      const proItem = this.projectOptions.find((t) => t.value === val);
      this.form.INSURANCE.rules.splice(index, 1, {
        ...tt,
        projectName: proItem.label,
      });
    },
    handleAddInsure() {
      // 添加投保规则
      const list = this.form.INSURANCE.rules;
      list.push({
        projectId: '',
        projectName: '',
        value: '',
      });
      this.$set(this.form.INSURANCE, 'rules', list);
    },
    handleDeleteInsure(index) {
      // 删除投保规则
      const list = this.form.INSURANCE.rules;
      list.splice(index, 1);
      this.$set(this.form.INSURANCE, 'rules', list);
    },
    handelScroll() {
      const { scrollTop } = document.getElementById('popContainer');
      const siteRuleHeight = this.$refs.site.offsetHeight;
      const goodRuleHeight = this.$refs.goods.offsetHeight + siteRuleHeight;
      const timeRuleHeight = this.$refs.order.offsetHeight + goodRuleHeight;
      const prepaymentHeight = this.$refs.prepayment.offsetHeight + timeRuleHeight;
      if (scrollTop > prepaymentHeight) {
        this.active = 5;
      } else if (scrollTop > timeRuleHeight) {
        this.active = 4;
      } else if (scrollTop > goodRuleHeight) {
        this.active = 3;
      } else if (scrollTop > siteRuleHeight) {
        this.active = 2;
      } else {
        this.active = 1;
      }
    },
    async valiForm() {
      await this.$refs.form.validate();
      const data = Object.keys(JSON.parse(JSON.stringify(this.form)));
      // 保险那一块，数据类型为Number，不能传字符串
      const res = data.map((item) => ({
        ruleCode: item,
        ruleValue: item !== 'INSURANCE' ? this.form[item] : {
          ...this.form.INSURANCE,
          defaultValue: this.form.INSURANCE.flag ? this.form.INSURANCE.defaultValue : '',
          rules: this.form.INSURANCE.rules && this.form.INSURANCE.rules.length > 0 ? this.form.INSURANCE.rules.map((m) => ({
            ...m,
            value: Number(m.value),
          })) : [],
        },
      }));
      return {
        form: this.form,
        res,
      };
    },
    clearValidate(prop) {
      this.$refs.form.clearValidate(prop);
    },
    handleConfig() {
      this.$refs.multiPiecesConfig.show(this.customersDetail);
    },
    async getParentMarkList() {
      const { ownerTenantId, customerCode } = this.customersDetail || {};
      const res = await parentMarkList({
        customerCode,
        tenantId: ownerTenantId,
        statuses: [markStatus.ENABLE, markStatus.RECONCILED],
      });
      this.MarkListTotal = res.length || 0;
    },
    handleRefreshMarkTotal() {
      this.getParentMarkList();
    },
  },
};
</script>

<style lang="scss" scoped>
.create-order{
  display: flex;
  flex-direction: row-reverse;
  box-sizing: border-box;
  padding:0 24px 24px;
  padding-bottom: 40px;
  .create-order_form{
    flex: 1;
    border-right: 1px solid #ECEDEE;
  }
  .rule-nav{
    height: 100%;
    position: sticky;
    top: 62px;
    background: #fff;
    width: 200px;
    padding: 24px 0;
    font-size: 12px;
    .nav_item{
      cursor: pointer;
      line-height: 32px;
      position: relative;
      padding: 0 16px;
      color: #323233;
      &::before{
        content:'';
        display: inline-block;
        height: 32px;
        width: 2px;
        background: #fff;
        position: absolute;
        left: 0px;
      }
    }
    .active{
      color: #059E84;
      &::before{
        background-color: #059E84;
      }
    }
  }
  ::v-deep .title_bar{
    border-bottom: 1px solid #D9DBDE;
  }
  .title-block{
    padding-top:24px;
  }
  .marginBottom{
    margin:8px 0 24px;
  }
  ::v-deep .el-radio{
    margin-right:8px;
  }
  .text-wrapper{
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
    }
    .text2{
      font-size: 13px;
      color:#808792;
      margin-left:8px;
    }
  }
}
.deliverTime_row{
  padding-top: 8px;
  .form_item_deliverTime{
    .el-form-item__label{
      padding: 0;
    }
    .el-input{
      width: 160px;
      margin-right: 8px;
    }
    .el-select{
      width: 80px;
    }
  }
}
.rule_input{
  ::v-deep.el-form-item__content{
    display: flex;
    align-items: center;
  }
  .el-input{
    width: 45%;
  }
  .rule_sign{
    margin: 0 8px;
    width: 14px;
    height: 1px;
    background: #B3B7BE;
  }
}
.weight_volume_rule_input{
  .el-input{
    width: calc(90% + 30px) ;
  }
}
.el-icon-warning{
  cursor: pointer;
}
.addOrCondition_btn{
  cursor: pointer;
  height: 38px;
  border: 1px dashed #B3B7BE;
  font-size: 14px;
  margin-bottom: 24px;
  .el-icon-plus{
    margin-right: 10px;
  }
  &:hover{
    border-color: #51CDA6;
    color: #51CDA6;
  }
  &:focus{
    border-color: #059366;
    color: #059366;
  }
}
.danger{
  color:red;
  position: relative;
  top:30px;
}
.el-select{
  width: 100%;
}
.tips_text{
  font-size: 14px;
  font-weight: 400;
  margin-left: 12px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
.orderBusinessLabel {
  .businessLabelItem {
    width: 90px;
    .business_label {
      font-size: 14px;
      color: #404B5C;
    }
    .business_tips_text {
      cursor: pointer;
      margin-left: 4px;
    }
  }

}
</style>
